// Hợp đồng
export default {
  Auto: 1, // 'Mặc định',
  SelfSetting: 0, // 'Tự thiết lập'
};
